import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export function companyList() {
    return axios.post(`${base.url}/auth/company/list`);
}
export function editcompanyList(data) {
    return axios.post(`${base.url}/auth/company/edit`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function addcompanyList(data) {
    return axios.post(`${base.url}/auth/company/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
}
export function resetAppkey(data) {
    return axios.post(`${base.url}/auth/company/reset`, qs.stringify(data));
}
export function delcompanyList(id) {
    return axios.get(`${base.url}/auth/company/del?id=${id}`);
}
export function companyStatus(data) {
    return axios.get(`${base.url}/auth/company/status?id=${data.id}&status=${data.status}`);
}
export function companyListAll() {
    return axios.get(`${base.url}/auth/business/listAll`);
}

